import type { JSX } from 'react';
import { useContext, createContext } from 'react';
import type { WistiaPlayer } from '@wistia/wistia-player';

const WistiaPlayerContext = createContext<WistiaPlayer | null | undefined>(undefined);

type WistiaPlayerProviderType = {
  children: React.ReactNode;
  player: WistiaPlayer | null;
};

// WistiaPlayerProvider is used to pass a public api instance of a player to deeply
// nested components that wish to reference its data
export const WistiaPlayerProvider = ({
  player,
  children,
}: WistiaPlayerProviderType): JSX.Element => {
  return <WistiaPlayerContext.Provider value={player}>{children}</WistiaPlayerContext.Provider>;
};

export const useWistiaPlayer = (): WistiaPlayer | null => {
  const player = useContext(WistiaPlayerContext);
  if (player === undefined) {
    throw new Error('useWistiaPlayer must be used within a WistiaPlayerProvider');
  }
  return player;
};
